// @ts-nocheck
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import React from "react";

export function FormSelect(props) {
    const { name, label, selectedValue, onChange, items, className, disabled, sx, fromAlias = false } = props;

    return (
        <FormControl
            sx={sx}
            variant="outlined"
            margin="dense"
            className={className}
        >
            <InputLabel>{label}</InputLabel>
            <Select
                name={name}
                disabled={disabled}
                label={label}
                value={selectedValue ? selectedValue.id ? selectedValue.id : selectedValue : ''}
                onChange={(e) => onChange(e)}
                style={{ height: '56px' }}
            >
                {
                    items.map(
                        (item, index) => (
                            <MenuItem key={index} name={name} value={item.id}>{fromAlias ? item.name : item.nombre}</MenuItem>
                        )
                    )
                }
            </Select>
        </FormControl>
    );
}